import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78b084aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=78b084aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b084aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b084aa')) {
      api.createRecord('78b084aa', component.options)
    } else {
      api.reload('78b084aa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78b084aa&scoped=true", function () {
      api.rerender('78b084aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjStatusTabs/index.vue"
export default component.exports